import { PurchaseActions, PurchaseActionTypes } from "../actions/purchase.action";

export interface PurchaseState {
  purchases: any[];
  purchasesLoading: boolean;
  purchasesError: boolean;

  createPurchaseLineItemSuccess: boolean;
  createPurchaseLineItemLoading: boolean;
  createPurchaseLineItemError: boolean;
  createdPurchaseLineItems: any[];

  purchaseSizes: any[];
  purchaseSizesLoading: boolean;
  purchaseSizesError: boolean;

  drawingLayoutDetail: any[];
  drawingLayoutDetailLoading: boolean;
  drawingLayoutDetailError: boolean;

  createPurchaseLineItemConfigSuccess: boolean;
  createPurchaseLineItemConfigLoading: boolean;
  createPurchaseLineItemConfigError: boolean;
  createdPurchaseLineItemConfigs: any[];

  matchedPricing: any[];
  matchedPricingLoading: boolean;
  matchedPricingError: boolean;

  fpProjectCategories: any[];
  fpProjectCategoriesLoading: boolean;
  fpProjectCategoriesError: boolean;
  
  fpProjectSubCategories: any[];
  fpProjectSubCategoriesLoading: boolean;
  fpProjectSubCategoriesError: boolean;
  
  fpProjectSizes: any[];
  fpProjectSizesLoading: boolean;
  fpProjectSizesError: boolean;
  
  fpProjectExtras: any[];
  fpProjectExtrasLoading: boolean;
  fpProjectExtrasError: boolean;
  
  fpProjectCategorySize: any[];
  fpProjectCategorySizeLoading: boolean;
  fpProjectCategorySizeError: boolean;

  fpProjectList: any[];
  fpProjectListLoading: boolean;
  fpProjectListError: boolean;

  fpProjectPriceList: any[];
  fpProjectPriceListLoading: boolean;
  fpProjectPriceListError: boolean;

  updatePurchaseLineItemSuccess: boolean;
  updatePurchaseLineItemLoading: boolean;
  updatePurchaseLineItemError: boolean;
  updatedPurchaseLineItem: any;
}

export const initialState: PurchaseState = {
  purchases: [],
  purchasesLoading: false,
  purchasesError: false,

  createPurchaseLineItemSuccess: false,
  createPurchaseLineItemLoading: false,
  createPurchaseLineItemError: false,
  createdPurchaseLineItems: [],

  purchaseSizes: [],
  purchaseSizesLoading: false,
  purchaseSizesError: false,

  drawingLayoutDetail: [],
  drawingLayoutDetailLoading: false,
  drawingLayoutDetailError: false,

  createPurchaseLineItemConfigSuccess: false,
  createPurchaseLineItemConfigLoading: false,
  createPurchaseLineItemConfigError: false,
  createdPurchaseLineItemConfigs: [],

  matchedPricing: [],
  matchedPricingLoading: false,
  matchedPricingError: false,

  fpProjectCategories: [],
  fpProjectCategoriesLoading: false,
  fpProjectCategoriesError: false,
  
  fpProjectSubCategories: [],
  fpProjectSubCategoriesLoading: false,
  fpProjectSubCategoriesError: false,
  
  fpProjectSizes: [],
  fpProjectSizesLoading: false,
  fpProjectSizesError: false,
  
  fpProjectExtras: [],
  fpProjectExtrasLoading: false,
  fpProjectExtrasError: false,

  fpProjectCategorySize: [],
  fpProjectCategorySizeLoading: false,
  fpProjectCategorySizeError: false,

  fpProjectList: [],
  fpProjectListLoading: false,
  fpProjectListError: false,

  fpProjectPriceList: [],
  fpProjectPriceListLoading: false,
  fpProjectPriceListError: false,

  updatePurchaseLineItemSuccess: false,
  updatePurchaseLineItemLoading: false,
  updatePurchaseLineItemError: false,
  updatedPurchaseLineItem: null
};

export function reducer(
  state = initialState,
  action: PurchaseActions
): PurchaseState {
  switch (action.type) {
    case PurchaseActionTypes.GET_PURCHASE_PRICE_LIST: {
      return {
        ...state,
        purchasesLoading: true,
        purchasesError: false,
      };
    }

    case PurchaseActionTypes.GET_PURCHASE_PRICE_LIST_SUCCESS: {
      return {
        ...state,
        purchases: action.payload,
        purchasesLoading: false,
        purchasesError: false,
      };
    }

    case PurchaseActionTypes.GET_PURCHASE_PRICE_LIST_FAILURE: {
      return {
        ...state,
        purchasesLoading: false,
        purchasesError: true,
      };
    }

    case PurchaseActionTypes.CLEAR_PURCHASE_PRICE_LIST: {
      return {
        ...state,
        purchases: []
      };
    }
    
    case PurchaseActionTypes.CLEAR_PURCHASE_CONFIG: {
      return {
        ...state,
        createdPurchaseLineItemConfigs: [],
        createPurchaseLineItemConfigSuccess: false,
        createPurchaseLineItemConfigLoading: false,
        createPurchaseLineItemConfigError: false,
      };
    }

    case PurchaseActionTypes.GET_PURCHASE_SIZE: {
      return {
        ...state,
        purchaseSizesLoading: true,
        purchaseSizesError: false,
      };
    }
  
    case PurchaseActionTypes.GET_PURCHASE_SIZE_SUCCESS: {
      return {
        ...state,
        purchaseSizes: action.payload,
        purchaseSizesLoading: false,
        purchaseSizesError: false,
      };
    }
  
    case PurchaseActionTypes.GET_PURCHASE_SIZE_FAILURE: {
      return {
        ...state,
        purchaseSizesLoading: false,
        purchaseSizesError: true,
      };
    }

    case PurchaseActionTypes.GET_DRAWING_LAYOUT_DETAIL: {
      return {
        ...state,
        drawingLayoutDetailLoading: true,
        drawingLayoutDetailError: false,
      };
    }

    case PurchaseActionTypes.GET_DRAWING_LAYOUT_DETAIL_SUCCESS: {
      return {
        ...state,
        drawingLayoutDetail: action.payload,
        drawingLayoutDetailLoading: false,
        drawingLayoutDetailError: false,
      };
    }

    case PurchaseActionTypes.GET_DRAWING_LAYOUT_DETAIL_FAILURE: {
      return {
        ...state,
        drawingLayoutDetailLoading: false,
        drawingLayoutDetailError: true,
      };
    }

    case PurchaseActionTypes.GET_MATCHED_PRICE_LIST: {
      return {
        ...state,
        matchedPricingLoading: true,
        matchedPricingError: false,
      };
    }

    case PurchaseActionTypes.GET_MATCHED_PRICE_LIST_SUCCESS: {
      return {
        ...state,
        matchedPricing: action.payload,
        matchedPricingLoading: false,
        matchedPricingError: false,
      };
    }

    case PurchaseActionTypes.GET_MATCHED_PRICE_LIST_FAILURE: {
      return {
        ...state,
        matchedPricingLoading: false,
        matchedPricingError: true,
      };
    }

    case PurchaseActionTypes.CLEAR_MATCHED_PRICE_LIST: {
      return {
        ...state,
        matchedPricing: []
      };
    }

    case PurchaseActionTypes.CREATE_PURCHASE_LINE_ITEM: {
      return {
        ...state,
        createPurchaseLineItemLoading: true,
        createPurchaseLineItemError: false,
      };
    }

    case PurchaseActionTypes.CREATE_PURCHASE_LINE_ITEM_SUCCESS: {
      return {
        ...state,
        createdPurchaseLineItems: [...state.createdPurchaseLineItems, action.payload],
        createPurchaseLineItemSuccess: true,
        createPurchaseLineItemLoading: false,
        createPurchaseLineItemError: false,
      };
    }

    case PurchaseActionTypes.CREATE_PURCHASE_LINE_ITEM_FAILURE: {
      return {
        ...state,
        createPurchaseLineItemLoading: false,
        createPurchaseLineItemError: true,
      };
    }

    case PurchaseActionTypes.CLEAR_PURCHASE_LINE_ITEM: {
      return {
        ...state,
        createdPurchaseLineItems: [],
        createPurchaseLineItemSuccess: false,
        createPurchaseLineItemLoading: false,
        createPurchaseLineItemError: false,
      };
    }

    case PurchaseActionTypes.CREATE_PURCHASE_LINE_ITEM_CONFIG: {
      return {
        ...state,
        createPurchaseLineItemConfigLoading: true,
        createPurchaseLineItemConfigError: false,
      };
    }

    case PurchaseActionTypes.CREATE_PURCHASE_LINE_ITEM_CONFIG_SUCCESS: {
      return {
        ...state,
        createdPurchaseLineItemConfigs: [...state.createdPurchaseLineItemConfigs, action.payload],
        createPurchaseLineItemConfigSuccess: true,
        createPurchaseLineItemConfigLoading: false,
        createPurchaseLineItemConfigError: false,
      };
    }

    case PurchaseActionTypes.CREATE_PURCHASE_LINE_ITEM_CONFIG_FAILURE: {
      return {
        ...state,
        createPurchaseLineItemConfigLoading: false,
        createPurchaseLineItemConfigError: true,
      };
    }

    case PurchaseActionTypes.GET_FP_PROJECT_CATEGORY: {
      return {
        ...state,
        fpProjectCategoriesLoading: true,
        fpProjectCategoriesError: false,
      };
    }

    case PurchaseActionTypes.GET_FP_PROJECT_CATEGORY_SUCCESS: {
      return {
        ...state,
        fpProjectCategories: action.payload,
        fpProjectCategoriesLoading: false,
        fpProjectCategoriesError: false,
      };
    }

    case PurchaseActionTypes.GET_FP_PROJECT_CATEGORY_FAILURE: {
      return {
        ...state,
        fpProjectCategoriesLoading: false,
        fpProjectCategoriesError: true,
      };
    }

    case PurchaseActionTypes.GET_FP_PROJECT_SUB_CATEGORY: {
      return {
        ...state,
        fpProjectSubCategoriesLoading: true,
        fpProjectSubCategoriesError: false,
      };
    }

    case PurchaseActionTypes.GET_FP_PROJECT_SUB_CATEGORY_SUCCESS: {
      return {
        ...state,
        fpProjectSubCategories: action.payload,
        fpProjectSubCategoriesLoading: false,
        fpProjectSubCategoriesError: false,
      };
    }

    case PurchaseActionTypes.GET_FP_PROJECT_SUB_CATEGORY_FAILURE: {
      return {
        ...state,
        fpProjectSubCategoriesLoading: false,
        fpProjectSubCategoriesError: true,
      };
    }

    case PurchaseActionTypes.GET_FP_PROJECT_SIZE: {
      return {
        ...state,
        fpProjectSizesLoading: true,
        fpProjectSizesError: false,
      };
    }

    case PurchaseActionTypes.GET_FP_PROJECT_SIZE_SUCCESS: {
      return {
        ...state,
        fpProjectSizes: action.payload,
        fpProjectSizesLoading: false,
        fpProjectSizesError: false,
      };
    }

    case PurchaseActionTypes.GET_FP_PROJECT_SIZE_FAILURE: {
      return {
        ...state,
        fpProjectSizesLoading: false,
        fpProjectSizesError: true,
      };
    }

    case PurchaseActionTypes.GET_FP_PROJECT_EXTRAS: {
      return {
        ...state,
        fpProjectExtrasLoading: true,
        fpProjectExtrasError: false,
      };
    }

    case PurchaseActionTypes.GET_FP_PROJECT_EXTRAS_SUCCESS: {
      return {
        ...state,
        fpProjectExtras: action.payload,
        fpProjectExtrasLoading: false,
        fpProjectExtrasError: false,
      };
    }

    case PurchaseActionTypes.GET_FP_PROJECT_EXTRAS_FAILURE: {
      return {
        ...state,
        fpProjectExtrasLoading: false,
        fpProjectExtrasError: true,
      };
    }

    case PurchaseActionTypes.GET_FP_PROJECT_CATEGORY_SIZE: {
      return {
        ...state,
        fpProjectCategorySizeLoading: true,
        fpProjectCategorySizeError: false,
      };
    }

    case PurchaseActionTypes.GET_FP_PROJECT_CATEGORY_SIZE_SUCCESS: {
      return {
        ...state,
        fpProjectCategorySize: action.payload,
        fpProjectCategorySizeLoading: false,
        fpProjectCategorySizeError: false,
      };
    }

    case PurchaseActionTypes.GET_FP_PROJECT_CATEGORY_SIZE_FAILURE: {
      return {
        ...state,
        fpProjectCategorySizeLoading: false,
        fpProjectCategorySizeError: true,
      };
    }

    case PurchaseActionTypes.GET_FP_PROJECT_LIST: {
      return {
        ...state,
        fpProjectListLoading: true,
        fpProjectListError: false,
      };
    }

    case PurchaseActionTypes.GET_FP_PROJECT_LIST_SUCCESS: {
      return {
        ...state,
        fpProjectList: action.payload,
        fpProjectListLoading: false,
        fpProjectListError: false,
      };
    }

    case PurchaseActionTypes.GET_FP_PROJECT_LIST_FAILURE: {
      return {
        ...state,
        fpProjectListLoading: false,
        fpProjectListError: true,
      };
    }

    case PurchaseActionTypes.GET_FP_PROJECT_PRICE_LIST: {
      return {
        ...state,
        fpProjectPriceListLoading: true,
        fpProjectPriceListError: false,
      };
    }

    case PurchaseActionTypes.GET_FP_PROJECT_PRICE_LIST_SUCCESS: {
      return {
        ...state,
        fpProjectPriceList: action.payload,
        fpProjectPriceListLoading: false,
        fpProjectPriceListError: false,
      };
    }

    case PurchaseActionTypes.GET_FP_PROJECT_PRICE_LIST_FAILURE: {
      return {
        ...state,
        fpProjectPriceListLoading: false,
        fpProjectPriceListError: true,
      };
    }

    case PurchaseActionTypes.UPDATE_PURCHASE_LINE_ITEM: {
      return {
        ...state,
        updatePurchaseLineItemLoading: true,
        updatePurchaseLineItemError: false,
      };
    }

    case PurchaseActionTypes.UPDATE_PURCHASE_LINE_ITEM_SUCCESS: {
      return {
        ...state,
        updatePurchaseLineItemSuccess: true,
        updatePurchaseLineItemLoading: false,
        updatePurchaseLineItemError: false,
      };
    }

    case PurchaseActionTypes.UPDATE_PURCHASE_LINE_ITEM_FAILURE: {
      return {
        ...state,
        updatePurchaseLineItemLoading: false,
        updatePurchaseLineItemError: true,
      };
    }

    case PurchaseActionTypes.CLEAR_PURCHASE_LINE_ITEM_UPDATE: {
      return {
        ...state,
        updatePurchaseLineItemSuccess: false,
        updatePurchaseLineItemLoading: false,
        updatePurchaseLineItemError: false,
      };
    }

    default:
      return state;
  }
}
